export const verificationRouteNames = {
  default: 'account-verification',
}
